<template>
  <nav id="nav" class="nav">
    <div id="navbg" class="bg"></div>
    <div class="box clearfix">
      <a class="a_logo" href="/">
        <img class="logo" src="https://qn-sfe.yuketang.cn/o_1bpfrptlcaflochlas11h1s1c9.png" alt="logo">
      </a>
      <span class="right">
        <a href="/web" target="_blank" class="loginweb">{{$t('home.signin')}}</a>
         <el-popover
                    placement="right-start"
                    width="150"
                    trigger="hover"
                    popper-class="userInfoPopover"
                    v-if="userInfo && userInfo.name"
                >
                    <p class="name"><!-- 你好 -->{{$t('pc.common.hello')}}，{{ userInfo && userInfo.name | formatLength}}</p>
                    <p class="exit" @click="logout"><!-- 退出 -->{{$t('pc.common.exit')}}</p>
                    <span class="avatar-wrapper" slot="reference">
                      <div class="img-wrapper" :class="[userInfo && userInfo.avatar ? 'border':'']">
                        <img :src="userInfo && userInfo.avatar" alt=""/>
                      </div>
                      <img src="https://qn-sfe.yuketang.cn/o_1etdl5q5e11oegqeapq1391qcu9.png" v-if="userInfo && userInfo.isVip" class="icon-vip-img">
                    </span>
        </el-popover>
        
      </span>
      <template v-if="lang==='zh-cn'">
        <a href="/help" class="right">帮助中心</a>
        <a href="/en/set-meal" class="right" :class="{active: routeName==='set-meal'}">定价</a>
        <a href="/training/index" class="right">培训服务</a>
        <a href="/lesson/market/courseware" id="rainMarket" class="right">雨课件</a>
        <a href="/presenter" class="right">翻页笔</a>
        <a href="/download" class="right">下载</a>
        <a href="/" class="right" :class="{active: routeName==='index'}">首页</a>
      </template>
      <template v-else>
        <a href="/en/set-meal" class="right" :class="{active: routeName==='set-meal'}">{{$t('home.price')}}</a>
        <a href="/en/download" class="right" :class="{active: routeName==='download'}">{{$t('home.download')}}</a>
        <a href="/en/" class="right" :class="{active: routeName==='index'}">{{$t('home.home')}}</a>
      </template>
    </div>
  </nav>
</template>

<script>
import Cookies from 'js-cookie'
import { getMemberInfo } from "../libs/member.model"
import { getLength, substr } from '@/util/utils'
export default {
  data() {
    console.log(Cookies.get('django_language'), "Cookies.get('django_language')");
    return {
      lang: Cookies.get('django_language') || 'zh-cn',
      routeName: '',
      userInfo: {}
    }
  },
  created() {
    this.routerInit()
    this.init()
  },
  filters: {
    formatLength(val){
      if(val){
          let len = getLength(val);
          if(len > 6) {
              return substr(val, 3) + '...';
          }else {
              return val
          }
      }
    }
  },
  methods: {
    init() {
      // 获取用户以及用户会员信息
      getMemberInfo().then(res => {
        const { memberStatus, avatar, user_id, name } = res
        this.userInfo = {
          isVip: !!memberStatus,
          avatar,
          user_id,
          name
        }
      })
      // .catch(res => {
      //   console.info(res)
      //   try {
      //     const data = typeof res === 'string' ? (JSON.parse(res) || {}) : res;
      //     const { errcode } = data
      //     if(errcode) {
      //       const code = `${errcode}`
      //       const pathname = location.pathname
      //       if(code[0] == '4') {
      //         if(pathname === '/en/set-meal' || pathname === '/en/pay-list' || location.href.indexOf('set-meal') > -1 || location.href.indexOf('pay-list') > -1) {
      //           location.href = `${location.origin}/web?next=${pathname}&type=666`
      //         }   
      //       }
      //     }
      //   } catch (error) {
          
      //   }
      // })
    },
    routerInit() {
      if (location.pathname.indexOf('download') > -1) {
        this.routeName = 'download'
      } else if(location.pathname.indexOf('set-meal') > -1){
        this.routeName = 'set-meal'
      }else {
        this.routeName = 'index'
      }
    },
    changeLan(lang = 'zh-cn') {
      Cookies.set('django_language', lang)
      if (lang === 'zh-cn') {
        location.href = `//${location.host}`
      } else {
        location.reload()
      }
    },
    async logout(){
      const res = await request.get('/pc/web_logout')
      if(res && res.success) {
          window.location.href = location.origin + '/en/set-meal'
      }
    },
  }
}
</script>
<style lang="scss" scoped> 
  .nav {
    position: fixed;
    z-index: 50;
    width: 100%;
    left: 0;
    top: 0;
    color: #fff;
    background-color:rgba(0,0,0,0.8);
  }
  .nav .bg {position: absolute; left: 0; top: 0; width: 100%; height: 100%; display: none;}
  .nav .box {
    position: relative;
    max-width: 1170px;
    min-width: 1170px;
    margin: 0 auto;
    height: 74px;
    width: 100%;
  }
  .nav .box .logo {float: left; width: 94px; margin-top: 22px;}

  .nav .box .right {float: right; margin-left: 50px;margin-top:20px;   font-size: 13px; padding-top: 1px; box-sizing: border-box; height: 34px;line-height: 34px;}
  .nav .box .beta{width: 29px; vertical-align: super;}
  .nav .box a {color: #9B9B9B;display: inline-block;text-align: center;border-radius: 5px;}
  .nav .box a.active{color: #ffffff;}
  .nav .box a:hover{color: #ffffff;}
  .nav .box a.loginweb{
    background-color: #5096F5;color: #fff;width: 100px;
  }

  .nav {
    .language-change {
      margin-left: 30px !important;
      // font-size: 16px !important;
      // color: #fff;
      // font-weight: 500;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .avatar-wrapper {
    position: relative;
    width: 32px;
    height: 32px;
    margin-left: 20px;
    display: inline-block;
    vertical-align: middle;
    & .border{ 
      border: 1px solid rgba(80, 150, 245, 0.3);
    }
    .img-wrapper {
      position: relative;
      border-radius: 50%;
      width: 100%;
      height: 100%;
      overflow: hidden;
      img {
        position: absolute;
        width: calc(100% - 1px);
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    img.icon-vip-img {
      position: absolute;
      height: 16px;
      bottom: -3px;
      right: -5px;
      
    }
  }
</style>

<style lang="scss">
.userInfoPopover {
    padding: 10px 0 !important;
    p {
        padding: 8px 0;
        text-align: center;
        font-size: 14px;
        line-height: 18px;
        color: #9b9b9b;
        &.exit {
            cursor: pointer;
            color: #f84f41;
            &:hover {
                background: rgba(248,79,65,.1);
            }
        }
    }
    
}
</style>